import { getInjection } from '@/di/inversify.config';
import { Result } from '@/entities';
import { CurrencyFormat } from '@/entities/CurrencyFormat';

export const getCurrencyFormatUseCase = async (currencyId: string): Promise<Result<CurrencyFormat>> => {
	const lookupRepository = getInjection('ILookupRepository');
	return lookupRepository.getCurrencyFormat(currencyId);
};
